<template>
    <div class="login-form">
        <v-form @submit.prevent v-model="valid">
            <v-container class="ma-0 pa-0">
                <v-row>
                    <v-col cols =6>
                        <v-btn
                            class="authorization-disabled-btn authorization-btn"
                            color="#001055"
                            variant="flat"
                            height="52"
                            width="204">
                            Вход
                        </v-btn>
                    </v-col>
                    <v-col cols =6>
                        <v-btn
                            class="authorization-btn"
                            variant="text"
                            height="52"
                            width="204"
                            @click="changeForm()">
                            Регистрация
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-10 login-form-text-field"
                                color="#0075AA"
                                label="Введите почту"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="email"
                                :rules="[email_rules]">
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="mx-12">
                            <v-text-field
                                class="mt-5 login-form-text-field"
                                color="#0075AA"
                                label="Введите пароль"
                                variant="outlined"
                                clear-icon="mdi-close-circle"
                                clearable
                                v-model="password"
                                :rules="[password_rules]"
                                type="password">
                            </v-text-field>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="ml-10 mr-12 d-flex justify-start">
                            <div>
                                <v-checkbox
                                    color="#0075AA"
                                    v-model="remember_person"
                                />
                            </div>
                            <div class="ml-2 mt-4">
                                Запомнить меня
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="ml-12 mr-12 mt-n2 d-flex justify-start login-form-error-msg">
                            {{ msg }}
                        </div>
                    </v-col>
                    <v-col cols="12">
                        <div class="ml-12 mr-12 mt-10 d-flex justify-start">
                            <div>
                                <v-btn
                                    type="submit"
                                    variant="flat"
                                    color="#0075AA"
                                    width="128"
                                    height="48"
                                    @click="login"
                                    >
                                    Войти
                                </v-btn>
                            </div>
                            <div
                                class="ml-6 mt-2 login-link"
                                @click="resetPassword"
                            >
                                Забыли пароль ?
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>
<script>

import { useAuthStore } from '@/store/auth'

export default {
    name: 'LoginForm',
    data() {
        return {
            email: '',
            password: '',
            remember_person: true,
            msg: '',
            valid: false,
            email_rules: (value) => {
                if (!value)
                    return "Необходимо ввести почту";
                if (!/.+@.+\.\w{2,4}/.test(value))
                    return 'Недействительная электронная почта';
                return true
            },
            password_rules: (value) => {
                if (!value)
                    return "Необходимо ввести пароль";
                if (value.length >20)
                    return "Пароль не должен быть длиннее 20 символов";
                if (value.length < 6)
                    return "Пароль не должен быть короче 6 символов";
                if (value.indexOf(" ") >0)
                    return "Пароль не должен содержать пробелы";
                return true;
            },
        }
    },
    methods: {
        changeForm(){
            this.$emit('changeForm')
        },
        resetPassword() {
            this.$emit('resetPassword')
        },
        async login(){
            if(!this.valid){
                this.msg = ""
                return
            }
            await useAuthStore().login(this.email, this.password)
            if (!this.remember_person)
                await useAuthStore().remove_token()
            if (useAuthStore().email){
                const router = this.$router
                await useAuthStore().getCurrentUser()
                router.push({"name": "Personalities", "params": {id: useAuthStore().id.toString()}})}
            else {
                this.msg = "Неправильный логин или пароль"
            }
            
        }
    }
}

</script>
